import React, { useEffect, useState } from 'react';
import {
  updateFlashBar,
  updateIsLoading,
  update_breadcrumb,
} from '../../redux/action';
import PageHeading from '../../components/PageHeading/PageHeading';
import { colors } from '../../config/constants';
import Input from '../../components/Input/Input';
import Button from '../../components/Button/Button';
import { useNavigate, useParams } from 'react-router-dom';
import instance from '../../service/axiosInstane';
import { useDispatch, useSelector } from 'react-redux';
import { StateProps } from '../../redux/reducer';
import { errorMessage } from '../../config/errorsMsg';
import { flashBarTheme } from '../../config/flashBar';
import Dailog from '../../components/Dailog/Dailog';
import { Role } from '../../config/enum';
import { successMessage } from '../../config/keyword';

type NoiseWordProps = {
  text: string;
  organizationId: string;
  id: string;
  isMasterData: boolean;
};

const NoiseWordsDetails = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const userInfo = useSelector((state: StateProps) => state.tokenInfo.userInfo);
  const { id } = useParams();
  const breadcrumb = [
    { path: '/noiseWords', name: 'Noise Word' },
    { path: `/noiseWordDetails/${id}`, name: 'Noise Word Details' },
  ];
  const [isDeletePopup, setIsDeletePopup] = useState(false);
  const [isSubmit, setIsSubmit] = useState(false);
  const [formError, setFormError] = useState<any>({});
  const [isTextEdit, setIsTextEdit] = useState(false);
  const [state, setState] = useState({
    text: '',
    id: '',
    isMasterData: false,
  });

  const [responseState, setResponseState] = useState({
    text: '',
    id: '',
  });

  const { text, isMasterData } = state;
  useEffect(() => {
    dispatch(update_breadcrumb(breadcrumb));
    getNoiseWordDetails();
  }, []);
  useEffect(() => {
    if (Object.keys(formError).length === 0 && isSubmit) {
      updateNoiseWord();
    }
  }, [formError]);

  const gotResponse = (data: NoiseWordProps) => {
    setState(data);
    setResponseState(data);
    dispatch(updateIsLoading(false));
  };
  const handleUpdate = () => {
    setFormError(validation());
    setIsSubmit(true);
  };
  const handleChangeText = (
    event: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>
  ) => {
    const format = /^\S*$/;
    format.test(event.target.value) &&
      setState({ ...state, [event.target.name]: event.target.value });
    if (event.target.value !== '' || Number(event.target.value) !== 0) {
      setFormError({ ...formError, [event.target.name]: undefined });
    } else {
      setFormError({
        ...formError,
        [event.target.name]: `Noise Word is required`,
      });
    }
  };

  const validation = () => {
    const error: any = {};
    if (!text) {
      error.text = errorMessage.emptyNoiseWord;
    } else if (text.length > 32) {
      error.text = errorMessage.noiseWordLength;
    }
    return error;
  };

  //when we click cancel button
  const handleUpdateCancel = () => {
    getNoiseWordDetails();
    setIsTextEdit(false);
    setIsSubmit(false);
    setFormError({});
  };

  const updateNoiseWord = () => {
    const obj = { text: text };
    dispatch(updateIsLoading(true));
    instance
      .put(`/noise-words/${state.id}`, obj)
      .then((response) => {
        if (response.status === 200) {
          const obj = {
            isOpen: true,
            message: successMessage.NOISEWORD_UPDATE,
            type: flashBarTheme.SUCCESS,
          };
          dispatch(updateFlashBar(obj));
        }
        getNoiseWordDetails();
      })
      .catch((err) => {
        const obj = {
          isOpen: true,
          message: err.response.data.Message,
          type: flashBarTheme.ERROR,
        };
        dispatch(updateFlashBar(obj));
        setState({ ...state, text: responseState.text });
      });
    setIsTextEdit(false);
    dispatch(updateIsLoading(false));
  };

  const getNoiseWordDetails = () => {
    dispatch(updateIsLoading(true));
    instance
      .get(`/noise-words/${id}`)
      .then((response) => {
        if (response.status === 200) {
          gotResponse(response.data);
          dispatch(updateIsLoading(false));
        }
      })
      .catch((err) => {
        const obj = {
          isOpen: true,
          message: err.response.data.Message,
          type: flashBarTheme.ERROR,
        };
        dispatch(updateFlashBar(obj));
      });
  };

  const onNoiseWordDelete = () => {
    instance
      .delete(`/noise-words/${id}`)
      .then((response) => {
        if (response.status === 200) {
          const obj = {
            isOpen: true,
            message: successMessage.NOISEWORD_DELETE,
            type: flashBarTheme.SUCCESS,
          };
          dispatch(updateFlashBar(obj));
          setIsDeletePopup(false);
          navigate('/noiseWords');
        }
      })
      .catch((err) => {
        const obj = {
          isOpen: true,
          message: err.response.data.Message,
          type: flashBarTheme.ERROR,
        };
        dispatch(updateFlashBar(obj));
      });
  };

  return (
    <>
      <div className="p-4">
        <PageHeading label="Noise Word Details" />
        <div
          className={`flex flex-col justify-between ${colors.primaryText} p-4 bg-white rounded-sm`}
        >
          <div className="sm:flex justify-between text-md ">
            <div className={``}>Noise Word</div>
            <div className=" w-1/2">
              {isTextEdit ? (
                <div>
                  <Input
                    placeholder={'Enter Noise Word'}
                    type={'text'}
                    value={text}
                    name="text"
                    onChange={(event) => {
                      handleChangeText(event);
                    }}
                    error={formError?.text}
                  />
                </div>
              ) : (
                <div className="text-sky-900">
                  {text}
                </div>
              )}
            </div>
            <div>
              <div className="flex justify-end gap-2">
                {isTextEdit ? (
                  <div className="flex space-x-3">
                    <Button
                      label="Update"
                      buttonType="primary"
                      type="button"
                      onClick={() => handleUpdate()}
                      disabled={text === responseState.text}
                    />
                    <Button
                      label="Cancel"
                      buttonType="danger"
                      type="button"
                      onClick={() => handleUpdateCancel()}
                    />
                  </div>
                ) : (
                  <>
                    {userInfo.role === Role.SuperAdmin ||
                    (userInfo.role === Role.Admin && !isMasterData) ? (
                      <Button
                        label="Edit"
                        buttonType="primary"
                        type="button"
                        onClick={() => setIsTextEdit(true)}
                      />
                    ) : null}
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="flex justify-center pt-8">
        {userInfo.role === Role.SuperAdmin ||
        (userInfo.role === Role.Admin && !isMasterData) ? (
          <Button
            label="Delete Noise Word"
            buttonType="danger"
            type="button"
            onClick={() => setIsDeletePopup(true)}
          />
        ) : null}
        <Dailog
          isDeletePopup={isDeletePopup}
          setIsPopupOpen={setIsDeletePopup}
          title={'Noise Word'}
          onConfirm={() => {
            onNoiseWordDelete();
          }}
        />
      </div>
    </>
  );
};

export default NoiseWordsDetails;
